export default __webpack_public_path__ + "static/media/NotImage.13811ac7.jpeg";